import * as React from "react";
import './Pick.css';
import '../../components/Typograph.css';
import PropTypes from "prop-types";
import PhoneAppHeader from "../../components/PhoneAppHeader";
import PhoneAppFooter from "../../components/PhoneAppFooter";

Result.propTypes = {
    handleNextPage: PropTypes.func.isRequired, disablePhoneMode: PropTypes.func.isRequired,
}

export default function Result(props) {
    return (<div className="page">
            <PhoneAppHeader title="Verstuurd"
                            quitPhoneApp={props.disablePhoneMode}
                            onPrevious={null}/>

            <div className="phone-page-middle">
                <h1 className="phone-pick-title" style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center"
                }}>
                    <span style={{
                        fontWeight: "900",
                        fontFamily: "Open Sans, sans-serif",
                        color: "#006443",
                        fontSize: "36px",
                    }}>
                    Bedankt<br/>
                    voor<br/>
                    uw<br/>
                    aanvraag,<br/>
                    </span>
                    <span style={{
                        fontSize: "24px",
                        lineHeight: "30px",
                        display: "block"
                    }}>
                        <br/>we gaan er direct
                        <br/> mee aan de slag!
                    </span>
                </h1>
            </div>
            <PhoneAppFooter onNext={props.handleNextPage}
                            last={true}
                            enableNext={true}
            />
        </div>);
}
